export var EditMode;
(function (EditMode) {
    EditMode[EditMode["View"] = 0] = "View";
    EditMode[EditMode["EnteringEdit"] = 1] = "EnteringEdit";
    EditMode[EditMode["Edit"] = 2] = "Edit";
    EditMode[EditMode["Saving"] = 3] = "Saving";
})(EditMode || (EditMode = {}));
//# sourceMappingURL=SxSEditState.js.map